/* eslint-disable */
import React, { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const ReviewLightbox = ({ images, index, onClose, onIndexChange }) => {
  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onIndexChange(Math.min(images.length - 1, index + 1));
      if (e.key === 'ArrowLeft') onIndexChange(Math.max(0, index - 1));
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [index, images.length, onClose, onIndexChange]);

  if (!images || images.length === 0) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black/85 flex items-center justify-center" onClick={onClose}>
      <button onClick={onClose} aria-label="Close gallery" className="absolute top-5 right-5 text-white hover:opacity-70">
        <X className="w-7 h-7" strokeWidth={1.4} />
      </button>
      <img
        src={images[index]}
        alt={`Review photo ${index + 1}`}
        className="max-h-[88vh] max-w-[92vw] object-contain"
        onClick={(e) => e.stopPropagation()}
      />
      {images.length > 1 && (
        <>
          <button onClick={(e) => { e.stopPropagation(); onIndexChange(Math.max(0, index - 1)); }}
            disabled={index === 0}
            aria-label="Previous photo"
            className="absolute left-5 top-1/2 -translate-y-1/2 text-white p-3 hover:bg-white/10 rounded-full disabled:opacity-30">
            <ChevronLeft className="w-7 h-7" strokeWidth={1.4} />
          </button>
          <button onClick={(e) => { e.stopPropagation(); onIndexChange(Math.min(images.length - 1, index + 1)); }}
            disabled={index === images.length - 1}
            aria-label="Next photo"
            className="absolute right-5 top-1/2 -translate-y-1/2 text-white p-3 hover:bg-white/10 rounded-full disabled:opacity-30">
            <ChevronRight className="w-7 h-7" strokeWidth={1.4} />
          </button>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white text-xs tracking-[0.22em]">
            {index + 1} / {images.length}
          </div>
        </>
      )}
    </div>
  );
};

export default ReviewLightbox;
